<template>
  <div class="app-push-activate" />
</template>

<script setup>
  import { onMounted } from 'vue'
  import { webViewHelper } from '@/common/util/web-view-helper'
  import { postUserPush } from '@/common/requests/data-fetch/post-user-push'
  import { useRoute } from 'vue-router/composables'

  const route = useRoute()
  const { appClose } = webViewHelper()

  const currentDate = new Date().toLocaleDateString()
  const message = `광고성 정보 수신 동의\n설정이 변경되었습니다.\n전송자: 콘텐츠웨이브(주)\nAPP PUSH: 수신함\n일자: ${currentDate}\n설정 > 알림 설정에서 변경할 수 있습니다.`

  const userPush = async () => {
    const credential = route.query.credential ?? ''
    const { data } = await postUserPush(credential)

    if (data) {
      const confirmed = window.confirm(message)
      if (confirmed) {
        return appClose()
      }
    }
  }

  const init = () => {
    userPush()
  }

  onMounted(() => {
    init()
  })
</script>
